import api from "@/api";
import { AxiosResponse } from "axios";

export interface HoldResponse {
  /** Ids of the seats the user now holds on the event. */
  seats: string[];
  /** When every held seat is released, unless the holds change again. */
  expires_at: string;
}

/** Holds one seat for the user, on top of the ones they already hold. Answers 409 when someone else has it. */
export default async function holdSeat(eventId: string, seatId: string): Promise<HoldResponse> {
  const response: AxiosResponse<HoldResponse> = await api.post(`/api/events/${eventId}/reservation/seats/${seatId}`);
  return response.data;
}
